// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Y7Ot","newExpiryDate":"styles_newExpiryDate__3X31w","footer":"styles_footer__1XPUO"};